.header {
  display: flex;
  box-sizing: border-box;
  min-height: 38px;
  border-bottom: var(--rc-calendar-border-base);

  .title {
    color: var(--rc-calendar-color-text-default);
    font-size: var(--rc-calendar-font-size-text-base);
  }

  .current-day {
    color: var(--rc-calendar-color-primary-default);
    font-weight: var(--rc-calendar-font-weight-bold);
  }

  .header-grid {
    display: grid;
    flex: 1;

    > div {
      box-sizing: border-box;
      border-right: var(--rc-calendar-border-base);

      &:last-child {
        border-right: 0;
      }
    }

    > .title-inner {
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      gap: var(--rc-theme-spacing-xxs);
    }
  }

  .header-day-grid {
    grid-template-columns: repeat(1, 1fr);

    > .title-inner {
      justify-content: start;
      padding-left: var(--rc-theme-spacing-ms);
    }
  }

  .header-week-grid {
    grid-template-columns: repeat(7, 1fr);
  }
}
